import { Component, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StockService } from '@appShared/services/stock.service';
import { IStock } from '@appShared/interfaces/[Model-based]/stock.interface';
import { StockEditModalComponent } from '../stock-edit/stock-edit-modal.component';

@Component({
  selector: 'app-stock-list',
   templateUrl: './stock-list.component.html',
   imports: [CurrencyPipe]
})
export class StockListComponent implements OnInit {
  stocks: IStock[] = [];
  isLoading: boolean;
  currentYearStockPricing: IStock;
  private _currentYear = new Date().getFullYear();

  constructor(
    private _stockService: StockService,
    private _modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this._getStocks();
  }

  /*
   * private methods
   * */

  private _getStocks(): void {
    this._stockService
      .getStocks()
      .then(stocks => {
        this.stocks = stocks;
        this.currentYearStockPricing = this.stocks.find(
          stock => stock.year === this._currentYear
        );
      })
      .catch(() => {
        /* Do Nothing */
      })
      .finally(() => (this.isLoading = false));
  }

  /*
   * public methods
   * */

  showStock(stock?: IStock): void {
    stock =
      stock ||
      ({
        id: 0,
        year: this._currentYear
      } as IStock);

    /* if creating new stock pricing and current year already exist - use it*/
    if (!stock.id && this.currentYearStockPricing) {
      stock = this.currentYearStockPricing;
    }

    const stockEditModalRef = this._modalService.open(StockEditModalComponent, {
      scrollable: true
      // windowClass: 'my-modal-md'
    });
    const shareholderStocksComponent = stockEditModalRef.componentInstance;
    shareholderStocksComponent.stock = { ...stock };
    shareholderStocksComponent.refreshGrid = this._getStocks.bind(this);
  }
}
